import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { Empty, message } from 'antd'
import moment from 'moment'

import ProfilesReportTopBar from './partials/ProfilesReportTopBar'
import QuotesReportContent from './partials/QuotesReportContent'
import QuotesReportForm from './partials/QuotesReportForm'

import { profilesWonQuotesReport } from './services'
import { handleError } from '../../helpers'

export default function ProfilesWonQuotes() {
	const [report, setReport] = useState(null)
	const [loading, setLoading] = useState(false)
	const [params, setParams] = useState({ 
		from: moment().startOf('month').format('YYYY-MM-DD').toString(),
		until: moment().endOf('month').format('YYYY-MM-DD').toString()
	})

	const onSubmit = () => {
		if(!params.from || !params.until) 
			return message.warning('Debe ingresar unas fechas correctas')

		setLoading(true)
		profilesWonQuotesReport(params)
			.then(res => setReport(res.data.data))
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<React.Fragment>
			<ProfilesReportTopBar 
				title="Perfiles de cotizaciones ganadas"
				subtitle="Ver las edades, géneros y número de acompañantes que más tienen cotizaciones con estado 'Compro en Spring'"
			/>
			<Row>
				<Col lg="3" md="4">
					<QuotesReportForm
						report={report}
						params={params}
						setParams={setParams}
						onSubmit={onSubmit}
						loading={loading}
					/>
				</Col>
				<Col>
					<Card>
						<CardBody>
							{ report ? (
								<QuotesReportContent 
									report={report}
									loading={loading}
								/>
							) : (
								<Empty description="Aún no ha generado el reporte" />
							)}
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}